// extracted by mini-css-extract-plugin
export default {"root":"BetaLabel_root__CEtQ8","absolute":"BetaLabel_absolute__YaLdZ"};